<section class="section-gap">
  <div *ngIf="panels" class="shadowed action-taxanomy-wrapper ">
    <kla-title class="mx-md-4 d-inline-block" [hideDots]="true" [lineConfig]="lineConfig"
               [config]="{header: config.title, description: config.description, badges: config.badges}"></kla-title>
    <mat-accordion>
      <kla-action-taxonomy-category *ngFor="let panel of panels" [categories]="categories"
                             [columnNames]="{ column1title: config.column1title, column2title: config.column2title, column3title: config.column3title, column4title: config.column4title, column5title: config.column5title}"
                             [columnsActive]="config.columnsActive"
                             [config]="panel"
                             [collapseChildren]="collapseChildren"></kla-action-taxonomy-category>
    </mat-accordion>
  </div>
</section>
